import { TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { NavigationRegion } from 'components/layout/pages/navigation-region';
import { SharedUiNavigationBarWrapper } from 'components/infosite/shared-ui/details/navigation-bar-wrapper';
import { z } from 'zod';

export const PropertyNavigation: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { config } = templateComponent;
  const configSchema = z.optional(
    z.object({
      showReserveBtn: z.optional(z.boolean()),
      showNightlyPrice: z.optional(z.boolean()),
      showReserveBtnOnLoad: z.optional(z.boolean()),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success) {
    return null;
  }
  const { showReserveBtn, showNightlyPrice, showReserveBtnOnLoad } = result.data ?? {};

  return (
    <NavigationRegion className="navigation-bar-region constrained">
      <SharedUiNavigationBarWrapper
        showReserveBtn={showReserveBtn}
        showNightlyPrice={showNightlyPrice}
        showReserveBtnOnLoad={showReserveBtnOnLoad}
      />
    </NavigationRegion>
  );
};
